import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';
import { ButtonSize, getButtonSpacing } from '../Button';

export const StyledFieldset = styled.fieldset`
  border: none;
  background: none;
  padding: 0;

  &:not(:last-child) {
    margin-bottom: ${tvar('space.x2')};
  }
`;

export const StyledLegend = styled.legend<{ $visible?: boolean }>`
  font-size: ${({ theme }) => theme.typographies.base.fontSize};
  font-weight: bold;
  display: block;
  margin: 0 0 ${tvar('space.x1')};
  ${({ $visible }) =>
    !$visible &&
    `
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  `}
`;

export const StyledRadioInput = styled.input`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const StyledRadios = styled.div<{ $disabled?: boolean }>`
  border: 0.1rem solid
    ${({ theme, $disabled }) =>
      $disabled
        ? theme.colors.button.disabled.border
        : theme.colors.button.primary.border};
  display: flex;
  align-items: center;
  height: 100%;
`;

export const StyledRadioLabel = styled.label<{ $buttonSize: ButtonSize }>`
  cursor: pointer;
  color: ${tvar('colors.typography.link')};
  text-align: center;
  padding: ${getButtonSpacing(0)} ${getButtonSpacing(1)};
  flex-grow: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: normal;

  &:not(:last-child) {
    border-right: 0.1rem solid ${tvar('colors.button.primary.border')};
  }

  input:checked + & {
    background-color: ${tvar('colors.button.primary.bg')};
    color: ${tvar('colors.button.primary.fg')};
  }

  input:focus + & {
    outline-width: 2px;
    outline-style: solid;
    outline-color: Highlight;
    @media (-webkit-min-device-pixel-ratio: 0) {
      outline-color: -webkit-focus-ring-color;
      outline-style: auto;
    }
  }

  input:disabled + & {
    color: ${tvar('colors.button.disabled.fg')};
    cursor: not-allowed;

    &:not(:last-child) {
      border-right: 0.2rem solid ${tvar('colors.button.disabled.border')};
    }
  }

  input:disabled:checked + & {
    background-color: ${tvar('colors.button.disabled.bg')};
  }
`;

export const StyledDescription = styled.p`
  font-weight: 300;
  font-size: 1.4rem;
  display: block;
  letter-spacing: 0.01em;
  margin: 0 0 ${tvar('space.x1')};
`;
